import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import {
  ContentWrapper,
  UploaderHeading,
  UploaderLabel,
  UploaderLink,
} from './styles';
import { ACCEPTED_FILE_TYPES } from '../constants';

type IdleStateProps = {
  onUploadFile: (uploadedFile: File) => void;
  onDragEnter: () => void;
  onDragLeave: () => void;
};

export const IdleState = ({
  onUploadFile,
  onDragEnter,
  onDragLeave,
}: IdleStateProps) => {
  const openFilePicker = (e: React.FormEvent, open: () => void) => {
    e.preventDefault();
    open();
  };

  const handleOnDrop = (acceptedFiles: File[]) => {
    onDragLeave();
    onUploadFile(acceptedFiles[0]);
  };

  return (
    <Dropzone
      onDrop={handleOnDrop}
      accept={ACCEPTED_FILE_TYPES}
      noClick
      noKeyboard
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
    >
      {({ getRootProps, getInputProps, open }) => {
        return (
          <ContentWrapper {...getRootProps()} data-testid="dropzone">
            <input {...getInputProps()} />
            <div>
              <UploaderHeading>
                Drag & drop files here to upload, or{' '}
                <UploaderLink onClick={e => openFilePicker(e, open)}>
                  browse
                </UploaderLink>
                .
              </UploaderHeading>
              <UploaderLabel>Supports [.mp4, .wav, .mov]</UploaderLabel>
            </div>
          </ContentWrapper>
        );
      }}
    </Dropzone>
  );
};
